import Basic from '@rebuild/materials/shared/home_wrapper/BaseWrapper.vue';
import MobBasic from '@rebuild/materials/shared/home_wrapper/MobHomeFlow.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/home_wrapper/context';
import { deepClone } from '@/utils/api';

function useSelfContext() {
	const governanceId = 'corporate_governance';

	const formattedMenus = (menus = []) => {
		const copyMenus = deepClone(menus);

		// 速腾聚创 —— 不展示简览入口
		const formatMenus = copyMenus.map(menu => {
			const hasGovernance = menu?.moduleVOS?.some(v => v.moduleId === governanceId);
			if (hasGovernance) {
				menu.moduleVOS = [];
			}
			return menu;
		});
		return formatMenus;
	};

	const formattedFlowMobMenus = (menus = []) => {
		return menus.filter(menu => !menu?.moduleVOS?.some(v => v.moduleId === governanceId));
	};

	provideCurrentContext({
		formattedMenus,
		formattedFlowMobMenus
	});
}

export const componentMap = {
	basic: withProvider(Basic, useSelfContext),
	'mob-basic': withProvider(MobBasic, useSelfContext)
};
